export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Bold-471244489c365983940cae6c84ac6e6c.eot";